import ReturnPolicy from '../../container/PolicyPages/ReturnPolicy';

function TermsConditions() {
  return <ReturnPolicy />;
}

export default TermsConditions;
